
  var _styles = {
  "comprehensive-card-privilege-container": {
    "width": "5.89333rem",
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "marginTop": "0.16rem"
  },
  "comprehensive-card-privilege-label-container": {
    "display": "flex",
    "alignItems": "center",
    "justifyContent": "center",
    "minWidth": "0.37333rem",
    "height": "0.37333rem",
    "borderRadius": "0.4rem",
    "marginRight": "0.06667rem"
  },
  "comprehensive-card-privilege-label": {
    "width": "0.4rem",
    "height": "0.4rem",
    "borderRadius": "0.2rem",
    "marginRight": "0.08rem"
  },
  "comprehensive-card-privilege-desc": {
    "flex": 1,
    "paddingTop": "0.06667rem",
    "fontWeight": "400",
    "fontFamily": "PingFangSC-Regular",
    "fontSize": "0.32rem",
    "color": "rgb(102,102,102)",
    "textAlign": "justify",
    "lineHeight": "0.33333rem"
  }
};



  module.exports = _styles;
  